import { gql } from '@apollo/client';
import { VideoType } from '../../common/helpers/domain/videoTypes';
import { ImageData, LocationItem, RoomType, Tag } from '../fragments/project';
import { PostSubcategory } from '../../common/helpers/domain/postCategories';

export const POST_DETAIL_QUERY = gql`
  query PostDetailQuery($id: Int) {
    post(request: { id: $id }) {
      id
      projectNetPropertyId
      title
      views
      date
      modified
      link
      content
      excerpt
      status
      author {
        id
        name
        nickname
        description
        link
        profileImage {
          url
          title
          width
          height
        }
        total_post
      }
      categories {
        id
        name
        link
      }
      tags {
        id
        name
        link
        slug
      }
      projectName
      propertyType
      postCategory
      videoType
      featuredImage {
        url
        title
        width
        height
      }
      heroImage {
        url
        title
        width
        height
      }
      articleHeroImage {
        url
        title
        width
        height
      }
      totalComments
      embedVideo
      postGallery {
        ID
        title
        caption
        alt_text
        url
        caption
        alt_text
        description
      }
      seo {
        keyword
        title
        metadesc
      }
      project {
        id
        name
        link
        propertyType
        developer
        location {
          zone {
            label
            value
            link
            parent {
              value
              label
              link
            }
          }
          district {
            label
            value
            link
            parent {
              value
              label
              link
            }
          }
          road {
            label
            value
            link
            parent {
              value
              label
              link
            }
          }
        }
        roomTypes {
          name
          status
          min_size
          max_size
        }
        transportations {
          value
          label
          link
        }
        priceTypes {
          starting_price
          level {
            value
            label
          }
        }
        leadCaptureFormId
        leadCaptureFormStartDate
        leadCaptureFormEndDate
      }
      heroImage {
        url
        title
        width
        height
      }
      contentAnchor {
        title
        description
      }
      contentAnchorGallery {
        ID
        title
        caption
        alt_text
        url
        caption
        alt_text
        description
      }
      latestReviewPost {
        id
        title
        date
        link
        featuredImage {
          url
          title
          width
          height
        }
      }
      videoAttributes {
        views
        likes
        thumbnailUrl
        uploadDate
      }
    }
  }
`;

export interface PostDetailQueryData {
  post: Post;
}

export interface PostDetailQueryVars {
  id: number;
}

export interface Post {
  id: number;
  title: string;
  seo: Seo;
  views: number;
  date: string;
  modified: string;
  link: string;
  content: string;
  excerpt: string;
  author: Author;
  categories: [Category];
  tags: Tag[];
  project: PostProject;
  projectName: string;
  propertyType: string[];
  postCategory: PostSubcategory;
  videoType: VideoType;
  featuredImage: ImageData;
  heroImage: ImageData;
  projectNetPropertyId?: string | number;
  articleHeroImage: ImageData;
  totalComments: number;
  embedVideo: string;
  videoAttributes: VideoAttributes;
  postGallery: PostGallery[];
  contentAnchor: ContentAnchor[];
  contentAnchorGallery: PostGallery[];
  status: string;
  articleTypeInGA: string;
  latestReviewPost?: LatestReviewPost;
}

export interface LatestReviewPost {
  id: string;
  title: string;
  date: string;
  link: string;
  excerpt: string;
  featuredImage: {
    url: string;
    title: string;
    width: number;
    height: number;
  };
}

export interface Author {
  id: number;
  total_post: string;
  profileImage?: ImageData;
  name: string;
  link: string;
  description: string;
  nickname: string;
}

export interface Seo {
  keyword: string;
  title: string;
  metadesc: string;
}

export interface Category {
  id: number;
  name: string;
  link: string;
}

export interface PostGallery {
  ID: string;
  title: string;
  alt_text: string;
  caption: string;
  description: string;
  url: string;
}

export interface ContentAnchor {
  title: string;
  description: string;
}

export interface PostProject {
  leadCaptureFormId: string;
  id: number;
  name: string;
  propertyType: string[];
  developer: string;
  location: {
    zone: LocationItem[];
    district: LocationItem[];
    road: LocationItem[];
  };
  roomTypes: RoomType[];
  transportations: {
    value: string;
    label: string;
    link: string;
  }[];
  priceTypes: ProjectPriceType;
  link?: string;
}

export interface ProjectPriceType {
  starting_price: string;
  level: {
    value: string;
    label: string;
  };
}

export interface VideoAttributes {
  views: number;
  likes: number;
  thumbnailUrl: string;
  uploadDate: string;
}
